type TCrossSectionSetting = {
	leftWidth?: number | string | null;
	rightWidth?: number | string | null;
	interpolationPitch?: number | string | null;
};

const isCrossSectionValueInRange = (
	value: number | string | null | undefined,
): boolean => {
	if (value === null || value === undefined || value === "") {
		return false;
	}

	const numericValue = Number(value);
	// Allow values > 0 (not >= 1) because unit conversion can produce sub-1m values (e.g. 0.3048m = 1ft)
	return (
		!Number.isNaN(numericValue) && numericValue > 0 && numericValue <= 999.999
	);
};

export const isCrossSectionSettingValid = (
	setting: TCrossSectionSetting | null | undefined,
): boolean => {
	if (!setting) {
		return false;
	}

	return (
		isCrossSectionValueInRange(setting.leftWidth) &&
		isCrossSectionValueInRange(setting.rightWidth) &&
		isCrossSectionValueInRange(setting.interpolationPitch)
	);
};
